import reply from "./messages/reply"

export const OPEN_FAN_KEY = 'communication-conversation-messages';

export const INITIATOR_APPLICANT = 'applicant';
export const INITIATOR_CUSTOMER = 'customer';

const store = {
	namespaced: true,
	modules: {
		reply
	},
	state: {
		show: false,
		applicantData: undefined,
		customerData: undefined,
		initiator: undefined,
		onClose: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setApplicantData', data.applicantData);
			commit('setCustomerData', data.customerData);
			commit('setInitiator', data.initiator);
			commit('setOnClose', data.onClose);

			commit('setShow', true);
		},
		close ({commit, state, dispatch})
		{
			if (state.onClose)
			{
				state.onClose();
			}

			commit('setShow', false);

			commit('setApplicantData', undefined);
			commit('setCustomerData', undefined);
			commit('setInitiator', undefined);
			commit('setOnClose', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});

			// always reload auth for red dots (job profiles)
			dispatch('auth/reloadIfCustomer', {}, { root: true });
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setApplicantData: (state, value) => state.applicantData = value,
		setCustomerData: (state, value) => state.customerData = value,
		setInitiator: (state, value) => state.initiator = value,
		setOnClose: (state, value) => state.onClose = value,
	},
};

export default store;
